import { render, staticRenderFns } from "./dimssa-button.vue?vue&type=template&id=16140975&scoped=true"
import script from "./dimssa-button.vue?vue&type=script&lang=ts"
export * from "./dimssa-button.vue?vue&type=script&lang=ts"
import style0 from "./dimssa-button.vue?vue&type=style&index=0&id=16140975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16140975",
  null
  
)

export default component.exports